/**
 * Narrows any non-null object, arrays included — the guard for walking parsed JSON, where an array
 * is as valid a node as an object. Use {@link isPlainObject} when an array must not pass.
 */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

/**
 * Narrows an object literal: rejects arrays, `Date`s and other class instances, so the value can be
 * spread, merged or indexed as a record of its own fields.
 */
export const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (!isRecord(value)) return false;
  return value.constructor === Object || value.constructor === undefined;
};
